import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AuthState, AuthUser } from '../types/auth.types';

const initialState: AuthState = {
  user: null,
  accessToken: null,
  status: 'idle',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    /** Set both user + token after a successful login. */
    setCredentials(
      state,
      action: PayloadAction<{ user: AuthUser; accessToken: string }>,
    ) {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.status = 'authenticated';
    },
    /** Update only the access token (after a silent refresh). */
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
      state.status = 'authenticated';
    },
    /** Update only the user record (after `/me` reload). */
    setUser(state, action: PayloadAction<AuthUser>) {
      state.user = action.payload;
      state.status = 'authenticated';
    },
    /** Wipe everything — used on logout and on refresh failure. */
    clearCredentials(state) {
      state.user = null;
      state.accessToken = null;
      state.status = 'unauthenticated';
    },
    /** Mark the session as known-unauthenticated (e.g. AuthProvider mount with no cookie). */
    markUnauthenticated(state) {
      state.status = 'unauthenticated';
    },
  },
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
